export default "__VITE_ASSET__625180f6__"